// Reports & Analytics config (PROMPT 16)
export const REPORT_TYPES = [
  { value: "lead_source", label: "Lead source report" },
  { value: "consultation", label: "Consultation report" },
  { value: "case_status", label: "Case status report" },
  { value: "service_lane", label: "Service lane report" },
  { value: "revenue", label: "Revenue report" },
  { value: "revenue_split", label: "Revenue split report" },
  { value: "partner_performance", label: "Partner performance report" },
  { value: "branch_performance", label: "Branch performance report" },
  { value: "trilogy_outreach", label: "Trilogy outreach report" },
  { value: "open_task", label: "Open task report" },
  { value: "overdue_task", label: "Overdue task report" },
  { value: "closed_case", label: "Closed case report" },
  { value: "monthly_business", label: "Monthly business report" },
];

export const LEAD_SOURCES = ["Website", "Referral", "Phone", "Event", "Trilogy", "Partner", "Other"];

// Keys whose values should render as currency in report tables
export const CURRENCY_KEYS = new Set(["expected", "actual", "revenue", "realized", "pipeline", "owed", "paid", "calc"]);
